<template>
  <section class="mx-3 lg:mx-0 max-w-screen-2xl">
    <div class="mt-10 lg:w-3/5 mx-auto">
      <div class="border-main rounded-lg">
        <div class="px-10 py-2" v-if="user.signupMode === 'password'">
          <div class="text-base font-bold text-root-2 pt-6 pb-4">
            Change Password
          </div>
          <el-form
            label-position="top"
            :model="updatePasswordForm"
            ref="updatePasswordForm"
            :rules="rules"
            label-width="80px"
            size="normal"
          >
            <el-form-item
              class="text-root-2"
              label="Current Password"
              prop="oldPassword"
            >
              <el-input
                name="oldPassword"
                class="border-main rounded-lg"
                placeholder="**********"
                show-password
                type="password"
                v-model="updatePasswordForm.oldPassword"
                autocomplete="off"
              ></el-input>
            </el-form-item>
            <el-form-item label="New password" prop="newPassword">
              <el-input
                name="newPassword"
                class="border-main rounded-lg"
                placeholder="**********"
                show-password
                type="password"
                v-model="updatePasswordForm.newPassword"
                autocomplete="off"
              ></el-input>
            </el-form-item>
            <p
              style="word-break: normal"
              class="text-xs -mt-2 mb-4 font-normal text-fg-muted"
            >
              Use 8 or more characters with a mix of letters, numbers & symbols
            </p>
            <el-form-item label="Confirm Password" prop="confirmPassword">
              <el-input
                name="confirmPassword"
                class="border-main rounded-lg"
                placeholder="**********"
                type="password"
                show-password
                v-model="updatePasswordForm.confirmPassword"
                autocomplete="off"
              ></el-input>
            </el-form-item>
            <div class="flex justify-end">
              <el-button
                @keyup.enter.native="validateForm('updatePasswordForm')"
                :loading="isLoading"
                @click="validateForm('updatePasswordForm')"
                class="w-1/5 bg-primary cursor-pointer rounded-lg py-4 flex justify-center items-center text-white font-normal"
              >
                {{ isLoading ? 'Saving...' : 'Save' }}
              </el-button>
            </div>
          </el-form>
        </div>
      </div>
    </div>
    <verify-auth-dialog
      v-if="showVerifyAuthDialog"
      :authState="authState"
      :showDialog="showVerifyAuthDialog"
      @closeDialog="closeDialog"
      @verifiedUser="changePassword"
    />
  </section>
</template>
<script>
import { PASSWORD_REGEX } from '@/utils/constants.js'
export default {
  data () {
    var validateNewPassword = (rule, value, callback) => {
      if (!PASSWORD_REGEX.test(value)) {
        callback(
          new Error(
            'Should contain atleast one number, one capital letter and one special character'
          )
        )
      } else {
        callback()
      }
    }
    var validateConfirmPassword = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('Please input the password again'))
      } else if (value !== this.updatePasswordForm.newPassword) {
        callback(new Error("Password inputs don't match!"))
      } else {
        callback()
      }
    }
    return {
      authState: 'updatePassword',
      showVerifyAuthDialog: false,
      emailNotificationsForm: {
        type: []
      },
      rules: {
        oldPassword: [
          {
            required: true,
            message: 'Please input your current password',
            trigger: ['blur', 'change']
          }
        ],
        newPassword: [
          {
            required: true,
            message: 'Please input the new password',
            trigger: ['blur', 'change']
          },
          {
            min: 8,
            message: 'password must be at least 8 characters long',
            trigger: ['blur', 'change']
          },
          { validator: validateNewPassword, trigger: ['blur', 'change'] }
        ],
        confirmPassword: [
          {
            validator: validateConfirmPassword,
            trigger: ['blur', 'change'],
            required: true
          }
        ]
      },
      updatePasswordForm: {
        newPassword: '',
        confirmPassword: '',
        oldPassword: ''
      },
      isLoading: false
    }
  },
  methods: {
    closeDialog () {
      this.showVerifyAuthDialog = false
    },
    validateForm (updatePasswordForm) {
      this.$refs[updatePasswordForm].validate((valid) => {
        if (valid) {
          this.showVerifyAuthDialog = true
        } else {
          this.$notify.error({
            title: 'Incomplete details',
            message: 'Please fill the missing Information',
            position: 'top-right'
          })
        }
      })
    },
    changePassword (twoFaCode) {
      const vm = this
      this.isLoading = true
      this.$store
        .dispatch('auth/changePassword', {
          ...this.updatePasswordForm,
          twoFaCode: twoFaCode.code
        })
        .then((res) => {
          this.$swal({
            icon: 'success',
            title: 'Password has been successfully reset',
            confirmButtonText: 'Proceed to login',
            iconColor: this.$primaryColor,
            allowOutsideClick: false
          }).then((result) => {
            if (result.isConfirmed) {
              this.$router.push({ name: 'login' })
            }
          })
        })
        .catch((error) => {
          this.handleErrorResponseNotification(error)
        })
        .finally(() => {
          this.isLoading = false
        })
    }
  },
  components: {
    VerifyAuthDialog: () => import('@/components/auth/VerifyAuthDialog.vue')
  },
  computed: {
    user () {
      return this.$store.state.auth.user
    }
  }
}
</script>
